<template>
  <div>
    <div v-if="baseRoute === 'clientSettings'" class="subnavHeader">
      <div
        class="subnavHeader__breadcrumb"
        @click="router.push({ name: 'clientOverview' })"
      >
        <font-awesome-icon
          class="breadcrumbIcon"
          icon="fa-solid fa-arrow-left"
        />
        <TitleRegular :title="routeTitle" />
      </div>
    </div>
    <div
      v-if="isSubnavVisible"
      class="subnav"
      :class="{ 'subnav--active': isSubnavVisible }"
    >
      <h4
        v-if="
          baseRoute != 'clientSettings' && baseRoute != 'contentGenerationV2'
        "
        class="subnav__parent"
      >
        {{ routeTitle }}
      </h4>
      <div v-if="baseRoute === 'clientOverview'" class="subnav__items">
        <router-link
          v-for="link in routes.workspace"
          :key="link.title"
          class="subnav__item__link"
          :to="{ name: link.route }"
        >
          <span class="subnav__item__link--text">{{ $t(link.title) }}</span>
        </router-link>
      </div>
      <div
        v-if="baseRoute === 'contentGenerationV2'"
        class="subnav__items caasSubnav"
      >
        <router-link
          v-for="link in routes.caas"
          :key="link.title"
          class="subnav__item__link"
          :to="{ name: link.route }"
        >
          <span class="subnav__item__link--text">{{ $t(link.title) }}</span>
        </router-link>
      </div>
      <div v-if="baseRoute === 'clientSettings'" class="subnav__items">
        <!-- Billing -->
        <DropdownLink
          :title="$t('customer.sub_nav.billing.btn')"
          :toggle-icon="show.billing"
          @click="toggleDropdown('billing')"
        />
        <div
          :class="{ active: show.billing }"
          class="subnav__items subnav__items--list"
        >
          <router-link
            v-for="(link, i) in routes.billing"
            :key="link.title + i"
            class="subnav__item__link"
            :to="{ name: link.route }"
          >
            <span class="subnav__item__link--text">{{ $t(link.title) }}</span>
          </router-link>
        </div>
        <!-- Team -->
        <DropdownLink
          :title="$t('shared.label.team')"
          :toggle-icon="show.team"
          @click="toggleDropdown('team')"
        />
        <div
          :class="{ active: show.team }"
          class="subnav__items subnav__items--list"
        >
          <router-link
            v-for="(link, i) in routes.team"
            :key="link.title + i"
            class="subnav__item__link"
            :to="{ name: link.route }"
          >
            <span class="subnav__item__link--text">{{ $t(link.title) }}</span>
          </router-link>
        </div>
        <!-- Account -->
        <DropdownLink
          :title="$t('shared.label.account')"
          :toggle-icon="show.account"
          data-cy="dropdown_account"
          @click="toggleDropdown('account')"
        />
        <div
          :class="{ active: show.account }"
          class="subnav__items subnav__items--list"
        >
          <router-link
            v-for="(link, i) in routes.account"
            :key="link.title + i"
            class="subnav__item__link"
            :to="{ name: link.route }"
          >
            <span class="subnav__item__link--text">{{ $t(link.title) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import TitleRegular from '@/components/shared/font/title/TitleRegular'
import i18n from '@/i18n'
import DropdownLink from '@/views/client/newGrid/subNav/DropdownLink'
import _ from 'underscore'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t
const route = useRoute()
const router = useRouter()

const show = ref({
  billing: true,
  team: false,
  account: false
})
const routeTitle = ref('')

const routes = computed(() => store.state.navigation.routes)
const baseRoute = computed(() => store.state.navigation.baseRoute)
const showNav = computed(() => store.state.navigation.showNav)
const isSubnavVisible = computed(() => {
  if (baseRoute.value == 'contentGenerationV2') return true
  return showNav.value
})

watch(
  () => route,
  (newRoute) => {
    showInitalDropdown()
    switch (newRoute.meta.baseRoute) {
      case 'clientSettings':
        routeTitle.value = $t('shared.nav.settings.btn')
        break
      default:
        routeTitle.value = $t('customer.nav.overview.title')
        break
    }
  },
  { deep: true, immediate: true }
)

function toggleDropdown(keyName) {
  if (show.value[keyName]) {
    show.value[keyName] = false
    if (keyName === 'billing') {
      router.push({ name: 'clientPaymentBilling' })
    }
    return
  }
  _.mapObject(show.value, (val, key) => {
    if (key === keyName) {
      show.value[key] = true
      if (keyName === 'billing') {
        router.push({ name: 'clientPaymentBilling' })
      }
    } else {
      show.value[key] = false
    }
  })
}
function showInitalDropdown() {
  _.mapObject(show.value, (val, key) => {
    if (key === route.meta.group) {
      show.value[key] = true
    } else {
      show.value[key] = false
    }
  })
}
</script>
<style lang="scss" scoped>
.subnav {
  display: grid;
  position: relative;
  grid-template-rows: 65px 1fr;
  padding: 15px;
  padding-bottom: 30px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #e6e9f0;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
}
.subnav__items {
  display: flex;
  flex-direction: column;
  grid-row: 2/2;
  &--list {
    overflow: hidden;
    max-height: 0;
    transition: max-height 500ms cubic-bezier(0.33, 1, 0.68, 1);
    will-change: max-height;
    &.active {
      max-height: 600px;
    }
  }
}

.subnavHeader {
  background: #ffffff;
  border: 1px solid $black-30;
  border-top: none;
  border-left: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  padding-right: 25px;
  height: auto;
  @include desktop() {
    height: 60px;
    position: absolute;
    top: 0;
    left: 60px;
    z-index: 3;
    width: calc(100% - 60px);
  }
  &__breadcrumb {
    display: none;
    align-items: center;
    cursor: pointer;
    @include desktop() {
      display: flex;
    }
    .breadcrumbIcon {
      padding: 8px;
      margin-right: 2px;
      border-radius: var(--border-radius);
      path {
        fill: #767c98;
      }
      &:hover {
        background: #f3f6fa;
      }
    }
  }
}

.caasSubnav {
  grid-row: 1;
}

.subnav__parent {
  display: flex;
  color: #454a5b;
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
  grid-row: 1/2;
}

.subnav__item__link {
  color: #767c98 !important;
  padding: 7px 10px;
  border-radius: 5px;
  word-break: break-word;
  text-decoration: none;
  &:hover {
    color: var(--main-blue-new) !important;
  }
  &.router-link-active {
    color: var(--main-blue-new) !important;
    background: #f3f6fa;
  }
}
</style>
